import React, { CSSProperties } from 'react';
import * as S from './styles';
import { FontFamilyType } from '@/styles/theme';

export type HeadingSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export type HeadingStyleProps = {
  $size: HeadingSize;
  $color: string;
  $weight: 'light' | 'regular' | 'medium' | 'bold';
  $align: 'left' | 'center' | 'right';
  $highContrast: boolean;
  $fontFamily?: FontFamilyType;
  $quebraTexto?: boolean;
};

export type HeadingProps = HeadingStyleProps & {
  $priority: HeadingSize;
  $text: string;
  style?: CSSProperties;
};

export default function Heading(props: HeadingProps) {
  const {
    $priority,
    $text,
    $quebraTexto = true,
    $fontFamily = 'text',
    style = {},
    ...restanteProps
  } = props;

  const propsContainer = { ...restanteProps, $quebraTexto, $fontFamily };

  return (
    <S.Container
      as={`h${$priority < 6 ? $priority : 6}`}
      {...propsContainer}
      style={style}
    >
      {$text}
    </S.Container>
  );
}
